export default function UserAvatar({ img, nick, size = 24 }) {
  return (
    <div className="client-user-cell">
      <div className="client-user-avatar" style={{ width: size, height: size }}>
        {img
          ? <img src={img} alt={nick} loading="lazy" />
          : (nick || '?')[0].toUpperCase()}
      </div>
      <span className="client-user-name">{nick?.split(' ')[0] || '—'}</span>
    </div>
  );
}
